(() => {
  const root = document.querySelector('[data-lds-acura-setup]');
  if (!root) return;
  root.addEventListener('change', event => {
    const select = event.target.closest('[data-lds-acura-addon-variant]');
    if (!select) return;
    root.querySelectorAll('[data-lds-acura-addon-variant]').forEach(other => { if (other !== select) other.value = ''; });
    const selectedAddon = select.selectedOptions[0]?.value ? select.selectedOptions[0] : undefined;
    const card = select.closest('[data-lds-acura-addon]');
    const link = card.querySelector('[data-lds-acura-view]');
    link.href = selectedAddon ? `${card.querySelector('.lds-acura-setup__image').href}?variant=${encodeURIComponent(selectedAddon.value)}` : card.querySelector('.lds-acura-setup__image').href;
  });
})();
